import { Component } from "@angular/core";
import { o7NodeService } from "@07/node-resource";
import { o7EventService } from "@07/utils";
import { Fylkeroversikt } from "../types";

@Component({
  template: require('./template.html'),
  styles: [require('./styles.scss')],
})
export class FylkerOverviewPage {
  node: any;

  constructor(private nodeService: o7NodeService, private events: o7EventService) {
    this.events.emit("loading-toggle", 1);
    this.nodeService.getNodeBySlug$("fylker").subscribe((node: Fylkeroversikt) => {
      this.node = node;
      this.events.emit("loading-toggle", -1);
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+fylker/overview/index.ts